import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";
import PrivateRoute from "./Utils/PrivateRoute";
import PreventedRoute from "./Utils/PreventedRoute";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import PrintBill from "./pages/PrintBill";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Same as */}
        <ToastContainer />
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Landing />
              </PrivateRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PreventedRoute>
                <Login />
              </PreventedRoute>
            }
          />
          <Route path="/generatebill" element={<PrintBill />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
